import React from "react";
import { Link } from "gatsby";
import { ArrowRight } from "./Icons";

/**
 * <Button to="/contact/">   internal (Gatsby Link)
 * <Button href="tel:...">   external / protocol links
 * variant: primary | secondary | brass | light | outline-light | ghost
 * size: sm | md | lg    arrow: append arrow icon
 */
export default function Button({ to, href, variant = "primary", size = "md", arrow = false, block = false, className = "", children, ...rest }) {
  const cls = ["btn", `btn-${variant}`, size !== "md" ? `btn-${size}` : "", block ? "btn-block" : "", className].filter(Boolean).join(" ");
  const inner = (<>{children}{arrow && <ArrowRight size={16} />}</>);
  if (to) return <Link to={to} className={cls} {...rest}>{inner}</Link>;
  if (href) return <a href={href} className={cls} {...rest}>{inner}</a>;
  return <button type="button" className={cls} {...rest}>{inner}</button>;
}
